export enum ModelUpdateType {
  CREATE,
  UPDATE,
  DELETE,
  REINSTATE,
}

export namespace ModelUpdateType {
  let elements = [
    ModelUpdateType.CREATE,
    ModelUpdateType.UPDATE,
    ModelUpdateType.DELETE,
    ModelUpdateType.REINSTATE,
  ];
  let alias = "com.bcdfx.model.event.admin.ModelUpdateType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
